import hexToRgb from 'src/utils/hexToRgb';
import { defineSlotRecipe } from '@chakra-ui/react';
import colors from '../colors';

const Dialog = defineSlotRecipe({
  slots: [
    'backdrop',
    'positioner',
    'content',
    'header',
    'body',
    'footer',
    'title',
    'description',
    'closeTrigger',
  ],
  base: {
    header: {
      fontSize: '30px',
      color: colors.podcastShade600,
      lineHeight: '36px',
      borderRadius: '8px 8px 0px 0px',
      bg: 'podcastShade100',
      p: '27px 40px',
      borderBottom: `2px solid ${colors.podcastShade200}`,
    },
    content: {
      boxShadow: '0px 8px 12px rgba(0, 0, 0, 0.06)',
      borderRadius: '8px',
    },
    body: {
      color: colors.podcastShade500,
      fontSize: '16px',
      pt: '18px',
      pb: '18px',
    },
    footer: {
      borderRadius: '0px 0px 8px 8px',
    },
    backdrop: {
      bg: hexToRgb(colors.podcastShade700, 0.7),
    },
  },
});

export default Dialog;
